export default __webpack_public_path__ + "dist/media/Expired.36114473.svg";